
<div class="info col-12 pt-5 px-3">
    <div class="info-icon"></div>
    <div class="info-title">
        <ng-content select="header"></ng-content>
    </div>
    <div class="info-content mt-2">
        <ng-content select="content"></ng-content>
        
        <div class="customer-service">
            <h5>Kontakt Kundeservice</h5>
            <p>Ønsker du hjælp til bestilling af lodder – så kontakt kundeservice via vores chat, <a href="mailto:kundeservice@klasselotteriet.dk">mail</a> eller telefon: <a href="tel:33420900">3342 0900</a></p>
        </div>
    </div>
</div>

